
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';

@Injectable()
export class AppNavigationService {
  constructor(
    private _permissionCheckerService: PermissionCheckerService,
    private _appSessionService: AppSessionService,
    private _projectService: ProjectService
  ) {}

  getAdminMenu() {
    return new AppMenu('MainMenu', 'MainMenu', [
      new AppMenuItem(
        'Admin',
        '',
        '',
        '',
        [],
        [
          new AppMenuItem(
            'Users',
            'Pages.StaffsAndUsers.Navigation',
            'fas fa-user-circle',
            '/app/main/resourcesAllocation/staffs'
          ),
          new AppMenuItem(
            'Roles',
            'Pages.Administration.Roles.Manage',
            'fas fa-user-cog',
            '/app/admin/roles'
          ),
          new AppMenuItem(
            'Projects',
            'Pages.Administration.Projects.Navigation',
            'fas fa-hard-hat',
            '/app/main/resourcesAllocation/projects'
          ),
          new AppMenuItem(
            'allo settings',
            '',
            'fas fa-cog',
            '/app/admin/allo-settings'
          ),
        ]
      ),

    ]);
  }

  getProjectMenu(){
    if (this._permissionCheckerService.isGranted("Pages.Role.Admin"))
    {
    return new AppMenu('MainMenu', 'MainMenu', [
      new AppMenuItem(
        'Manage',
        '',
        '',
        '',
        [],
        [
          new AppMenuItem(
            'Home',
            '',
            'fas fa-home ',
            '/app/main/dashboard'
          ),
          new AppMenuItem(
            'Complete forms',
            'Pages.Activities.Navigation',
            'far fa-clipboard',
            '/app/main/resourcesAllocation/activities'
          ),
          new AppMenuItem(
            'Submissions',
            'Pages.AllocationSheets.Navigation',
            'far fa-check-circle',
            '/app/main/resourcesAllocation/allocation-sheets'
          ),
          new AppMenuItem(
            'Reports',
            'Pages.Reports',
            'fas fa-chart-line',
            '/app/main/reports'
          )
        ]
      ),

      new AppMenuItem(
        'Admin',
        '',
        '',
        '',
        [],
        [
          new AppMenuItem(
            'Project team',
            'Pages.StaffsAndUsers.ProjectTeam.Navigation',
            'fas fa-user-circle',
            '/app/main/resourcesAllocation/projectteam'
          ),
          new AppMenuItem(
            'Project data',
            'Pages.Project.Grid.Project.Data',
            'fas fa-server',
            '/app/main/resourcesAllocation/projectdata'
          ),

          new AppMenuItem(
            'Manage forms',
            'Pages.Administration.OrganizationUnits.ManageForms',
            'fas fa-file-alt',
            '/app/main/settings/forms/manage'
          ),
        ]
      ),
    ])
  }
  else
  {
    return new AppMenu('MainMenu', 'MainMenu', [
    new AppMenuItem(
      'Manage',
      '',
      '',
      '',
      [],
      [
        new AppMenuItem(
          'Home',
          '',
          'fas fa-home ',
          '/app/main/dashboard'
        ),
        new AppMenuItem(
          'Complete forms',
          'Pages.Activities.Navigation',
          'far fa-clipboard',
          '/app/main/resourcesAllocation/activities'
        ),
        new AppMenuItem(
          'Submissions',
          'Pages.AllocationSheets.Navigation',
          'far fa-check-circle',
          '/app/main/resourcesAllocation/allocation-sheets'
        ),
        new AppMenuItem(
          'Reports',
          'Pages.Reports',
          'fas fa-chart-line',
          '/app/main/reports'
        ),
        new AppMenuItem(
          'Users',
          'Pages.StaffsAndUsers.Navigation',
          'fas fa-user-circle',
          '/app/main/resourcesAllocation/staffs'
        ),
        new AppMenuItem(
          'Roles',
          'Pages.Administration.Roles.Manage',
          'fas fa-user-cog',
          '/app/admin/roles'
        ),
        new AppMenuItem(
          'Projects',
          'Pages.Administration.Projects.Navigation',
          'fas fa-hard-hat',
          '/app/main/resourcesAllocation/projects'
        )
      ]
      ),
      new AppMenuItem(
        'Admin',
        '',
        '',
        '',
        [],
        [
          new AppMenuItem(
            'Project team',
            'Pages.StaffsAndUsers.ProjectTeam.Navigation',
            'fas fa-user-circle',
            '/app/main/resourcesAllocation/projectteam'
          ),
          new AppMenuItem(
            'Project data',
            'Pages.Project.Grid.Project.Data',
            'fas fa-server',
            '/app/main/resourcesAllocation/projectdata'
          ),
         
          new AppMenuItem(
            'Manage forms',
            'Pages.Administration.OrganizationUnits.ManageForms',
            'fas fa-file-alt',
            '/app/main/settings/forms/manage'
          ),
        ]
      ),
    ])
    }
  }

  getHostMenu(){
    return new AppMenu('MainMenu', 'MainMenu', [
      new AppMenuItem(
        'Host Admin',
        '',
        '',
        '',
        [],
        [
          new AppMenuItem(
            'Host dashboard',
            'Pages.Administration',
            'fas fa-tachometer-alt',
            '/app/admin/hostDashboard'
          ),
          new AppMenuItem(
            'Manage tenant',
            'Pages.Administration',
            'fa fa-tasks',
            '/app/admin/tenants'
          ),

          new AppMenuItem(
            'Roles',
            'Pages.Administration.Roles',
            'fa fa-users',
            '/app/admin/roles'
          ),
          new AppMenuItem(
            'Permission groups',
            'Pages.PermissionGroups',
            'fas fa-cog',
            '/app/admin/permission-groups'
          ),
          new AppMenuItem(
            'Editions',
            'Pages.Editions',
            'fas fa-donate',
            '/app/admin/edition-management'
          ),
          new AppMenuItem(
            'Announcements',
            'Pages.Announcements',
            'fa fa-rocket',
            '/app/admin/announcements'
          ),
          new AppMenuItem(
            'Manage forms',
            'Pages.Administration.OrganizationUnits.ManageForms',
            'fas fa-file-alt',
            '/app/main/settings/forms/manage'
          ),
        ]
      )
    ]);
  }

  async getMenu() {
    let tenantId = this._appSessionService.tenantId;
    if (!tenantId){
      return this.getHostMenu();
    }
    let projectId = await this._projectService.getCurrentOrDefaultProjectId();
    if(projectId){
      return this.getProjectMenu();
    }else{
      return this.getAdminMenu();
    }
  }

  checkChildMenuItemPermission(menuItem): boolean {
    for (let i = 0; i < menuItem.items.length; i++) {
      let subMenuItem = menuItem.items[i];

      if (
        subMenuItem.permissionName === '' ||
        subMenuItem.permissionName === null
      ) {
        if (subMenuItem.route) {
          return true;
        }
      } else if (
        this._permissionCheckerService.isGranted(subMenuItem.permissionName)
      ) {
        return true;
      }

      if (subMenuItem.items && subMenuItem.items.length) {
        let isAnyChildItemActive = this.checkChildMenuItemPermission(
          subMenuItem
        );
        if (isAnyChildItemActive) {
          return true;
        }
      }
    }
    return false;
  }

  showMenuItem(menuItem: AppMenuItem): boolean {
    if (
      menuItem.permissionName ===
      'Pages.Administration.Tenant.SubscriptionManagement' &&
      this._appSessionService.tenant &&
      !this._appSessionService.tenant.edition
    ) {
      return false;
    }

    let hideMenuItem = false;

    if (menuItem.requiresAuthentication && !this._appSessionService.user) {
      hideMenuItem = true;
    }

    if (
      menuItem.permissionName &&
      !this._permissionCheckerService.isGranted(menuItem.permissionName)
    ) {
      hideMenuItem = true;
    }

    if (
      this._appSessionService.tenant ||
      !abp.multiTenancy.ignoreFeatureCheckForHostUsers
    ) {
      if (
        menuItem.hasFeatureDependency() &&
        !menuItem.featureDependencySatisfied()
      ) {
        hideMenuItem = true;
      }
    }

    if (!hideMenuItem && menuItem.items && menuItem.items.length) {
      return this.checkChildMenuItemPermission(menuItem);
    }

    return !hideMenuItem;
  }

  /**
   * Returns all menu items recursively
   */
  async getAllMenuItems() {
    let menu = await this.getMenu();
    let allMenuItems: AppMenuItem[] = [];
    menu.items.forEach((menuItem) => {
      allMenuItems = allMenuItems.concat(
        this.getAllMenuItemsRecursive(menuItem)
      );
    });

    return allMenuItems;
  }

  private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
    if (!menuItem.items) {
      return [menuItem];
    }

    let menuItems = [menuItem];
    menuItem.items.forEach((subMenu) => {
      menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
    });

    return menuItems;
  }
}
